import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { sliderBanner, sliderItemClick } from '../../../actions/slidersAction';
import { getSliderSection } from '../../../actions/kafairAction';

class PromoBannerBank extends Component {
  constructor(props: Object) {
    super(props);
    this.state = {
      imageBanner: [],
    };
  }

  componentDidMount() {
    this._getSliderBanner();
  }

  _getSliderBanner = async () => {
    const { dataCategory } = this.props;
    // Ini masi hardcode
    const newCategory =
      dataCategory === 'bcaxkickavenue' ? 'bca' : dataCategory;
    const params = { params: { category: dataCategory } };

    // Get banner slider for sponsor
    this.props
      .getSliderSection(params)
      .then(({ value }: Object) => {
        this.setState({
          imageBanner: value.data,
        });
      })
      .catch((e: Object) => console.log(encodeURI));
  };

  navigateToPage = (redirect_url: string) => {
    window.open(redirect_url, "_blank")
  };

  render() {
    // Display sponsor banner if imageBanner is available
    if(this.state.imageBanner && this.state.imageBanner.length > 0){
      return (
        <div className="promo-banner-container">
          <h4 className="promo-banner-title">Best Offer For You</h4>
          {/* for desktop */}
          <div className="d-none d-sm-block">
            <div className="promo-banner-section">
              {
                this.state.imageBanner && this.state.imageBanner.length > 0 && this.state.imageBanner.map((item: Object, index: number) => {
                  return (
                    <div key={item.id} className="promo-banner" onClick={() => this.navigateToPage(item.redirect_url)}>
                        <KickImage
                          src={item.img_url}
                          className={`promo-img-${index + 1}`}
                        />
                    </div>
                  )
                })
              }
            </div>
          </div>

          {/* for mobile responsive */}
          <div className="d-block d-sm-none">
            <div className="promo-banner-section">
                {
                  this.state.imageBanner && this.state.imageBanner.length > 0 && this.state.imageBanner.map((item: Object, index: number) => {
                    const portraitImg = item.images.length > 0? item.images.find((item) => item.orientation === "portrait") : null;
                    
                    return (
                      <div key={item.id} className="promo-banner" onClick={() => this.navigateToPage(item.redirect_url)}>
                          <KickImage
                            src={portraitImg?.URL || item.img_url}
                            className="promo-img-1"
                          />
                      </div>
                    )
                  })
                }
              </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

interface PrevProps {
  category: string;
}
interface State {
  sliderHome: Array<Object>;
  dataAuth: any;
}

const mapStateToProps = (state: State) => ({
  sliderImages: state.sliderHome,
  dataAuth: state.dataAuth,
});

const mapDispatchToProps = (dispatch: any) => ({
  sliderBanner: (payload: Object) => dispatch(sliderBanner(payload)),
  sliderItemClick: (payload: Object) => dispatch(sliderItemClick(payload)),
  getSliderSection: (params: Object) => dispatch(getSliderSection(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoBannerBank);
